import { render, staticRenderFns } from "./Weights.vue?vue&type=template&id=5045361f&scoped=true&"
import script from "./Weights.vue?vue&type=script&lang=ts&"
export * from "./Weights.vue?vue&type=script&lang=ts&"
import style0 from "./Weights.vue?vue&type=style&index=0&id=5045361f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045361f",
  null
  
)

export default component.exports